module.exports = __webpack_public_path__ + "static/media/cellular-connection.cb3f72fd.svg";